import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "../../../../Shared/AssociateNavbar/Navbar";
import ReusableTable from "../../../../Layout/ReusableTable";
import baseURL from "../../../../Apiurs/Apiurls"; 
import { PDFDownloadLink, pdf } from "@react-pdf/renderer";
import InvoicePDF from "../../../Admin/Lead/ViewLeads/AddProduct";
import "../../../../Layout/Collapse/Collapse.css"
import AddProduct from "../../../Admin/Lead/ViewLeads/AddProduct";
import { 
  FiArrowLeft, 
  FiPlus, 
  FiFileText, 
  FiEye,
  FiDownload, 
  FiSend,
  FiDollarSign,
  FiPercent,
  FiShoppingCart,
  FiUser,
  FiMail,FiEdit,FiSave,FiX,
  FiPhone,
  FiGlobe,FiTrash2,
  FiRefreshCw
} from "react-icons/fi";
import "../../../Admin/Lead/ViewLeads/ViewLead.css";
import TermsConditions from "./TermsConditions";
import QuatationBody from "./QuatationBody";

const ViewLead = () => { 
  const { id } = useParams();
  const location = useLocation();
  const leadInfo = location.state?.lead || {};
  console.log("leadinfo", JSON.stringify(leadInfo, null, 2));
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false); 
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const OpenAddModal = () => setShowModal(true);
  const [quantities, setQuantities] = useState([]);
  const [quotationStatus, setQuotationStatus] = useState(""); 
  
  // New state for discount
  const [discount, setDiscount] = useState(0);
  const [discountType, setDiscountType] = useState('percentage'); // 'percentage' or 'amount'

  const handleNavigate = () => {
    navigate(`/s-raw-mail/${id}`, { state: { lead: leadInfo } });
  };


  useEffect(() => {
    setQuantities(products.map((item) => item.quantity));
  }, [products]);

  const handleQuantityChange = async (index, value) => {
    const qty = value === "" ? 1 : Math.max(1, parseInt(value, 10));

    // ✅ Update products state so table re-renders
    const updatedProducts = [...products];
    updatedProducts[index] = { ...updatedProducts[index], quantity: qty };
    setProducts(updatedProducts);

    // ✅ Update in DB via API
    try {
      await axios.post(`${baseURL}/api/update-quantity`, {
        product_id: updatedProducts[index].id, // ensure "id" is present in fetched data
        quantity: qty,
      });
      console.log("Quantity updated in DB successfully");
    } catch (err) {
      console.error("Error updating quantity in DB:", err);
      alert("Failed to update quantity in database.");
    }
  };

  const handlePriceChange = async (index, value) => {
  const price = value === "" ? 0 : Math.max(0, parseFloat(value));

  // ✅ Update products state so table re-renders
  const updatedProducts = [...products];
  updatedProducts[index] = { ...updatedProducts[index], listprice: price };
  setProducts(updatedProducts);

  // ✅ Update in DB via API
  try {
    await axios.post(`${baseURL}/api/update-price`, {
      product_id: updatedProducts[index].id,  // ensure id is present
      listprice: price,
    });
    console.log("Price updated in DB successfully");
  } catch (err) {
    console.error("Error updating price in DB:", err);
    alert("Failed to update price in database.");
  }
};


const handleQuoteStatus = async (id, status) => {
  setLoading(true); // start loading
  try {
    const res = await fetch(`${baseURL}/api/update-quotation-status/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ quotation_status: status }),
    });

    if (!res.ok) {
      const errorText = await res.text();
      console.error("Server error response:", errorText);
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    console.log("API Response:", data);

    // ✅ Update state immediately
    setQuotationStatus(status);

    if (status === "Quoted") {
      alert("The Quotation is marked as Quoted. Please wait for manager approval to send ✅");
    } else if (status === "Requoted") {
      alert("The Quotation is marked as Requoted 🔄");
    }
  } catch (error) {
    console.error("Error updating quote status:", error);
    alert("Failed to update quotation status. Please try again.");
  } finally {
    setLoading(false); // stop loading
  }
};


  // Also update the fetch function to ensure it gets the latest status
  const fetchLeadQuotationStatus = async () => {
    try {
      const res = await fetch(`${baseURL}/api/lead-quotation-status/${id}`);
      const data = await res.json();
      if (res.ok) {
        setQuotationStatus(data.quotation_status || "");
      }
    } catch (err) {
      console.error("Error fetching quotation status:", err);
    }
  };

  useEffect(() => {
    fetchLeadQuotationStatus();
  }, [id]);

  // totals
  const [subtotal, setSubtotal] = useState(0);
  const [totalGST, setTotalGST] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [finalTotal, setFinalTotal] = useState(0);

  // const fetchEmailProducts = async () => {
  //   try {
  //     const res = await axios.get(`${baseURL}/api/all-email-products/${id}`);
  //     const data = res.data.map((row) => ({
  //       id: row.id,
  //       ...row,
  //       gstrate: row.gstrate ?? 5,
  //       listprice: row.listprice ?? 200,
  //       quantity: row.quantity ?? 1,
  //     }));
  //     console.log("Fetched products:", data); // 👀 debug
  //     setProducts(data);  // replace completely
  //   } catch (err) {
  //     console.error("Error fetching email products:", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const [productDetails, setProductDetails] = useState([]);

const fetchEmailProducts = async () => {
  try {
    const [productsRes, detailsRes] = await Promise.all([
      axios.get(`${baseURL}/api/all-email-products/${id}`),
      axios.get(`${baseURL}/api/all-details`)
    ]);

    const productDetails = detailsRes.data;
    const products = productsRes.data.map((row) => ({
      id: row.id,
      ...row,
      gstrate: row.gstrate ?? 5,
      listprice: row.listprice ?? 200,
      quantity: row.quantity ?? 1,
      // Add the matching product image
      product_image: productDetails.find(detail => detail.detail_id == row.detail_id)?.product_image
    }));

    console.log("Fetched products with images:", products);
    setProducts(products);
    setProductDetails(productDetails);
  } catch (err) {
    console.error("Error fetching data:", err);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchEmailProducts();
  }, [id]);

  const handleSaveProduct = async (formData) => {
    try {
      const payload = { ...formData, lead_id: id };
      await axios.post(`${baseURL}/api/add-lead-product`, payload);

      alert("Product added successfully!");
      setShowModal(false);
      await fetchEmailProducts();   // ✅ force re-fetch
    } catch (err) {
      console.error("Error adding product:", err);
      alert("Failed to add product.");
    }
  };

  const handleDeleteProduct = async (productId) => {
    if (!window.confirm("Are you sure you want to delete this product?")) return;

    try {
      await axios.delete(`${baseURL}/api/delete-lead-product/${productId}`);
      alert("Product deleted successfully!");
      await fetchEmailProducts();  // ✅ force re-fetch
    } catch (err) {
      console.error("Error deleting product:", err);
      alert("Failed to delete product.");
    }
  };

  // calculate totals whenever products or discount change
  useEffect(() => {
    if (products.length > 0) {
      let sub = 0;
      let gstAmount = 0;

      products.forEach((p) => {
        const qty = p.quantity || 0;
        const price = p.listprice || 0;
        const gstRate = parseFloat(p.gstrate) || 0;

        const itemTotal = qty * price;
        const itemGST = (itemTotal * gstRate) / 100;

        sub += itemTotal;
        gstAmount += itemGST;
      });

      // Calculate discount amount
      let discountAmt = 0;
      if (discountType === 'percentage') {
        discountAmt = (sub * discount) / 100;
      } else {
        discountAmt = parseFloat(discount) || 0;
      }

      // Ensure discount doesn't exceed subtotal
      discountAmt = Math.min(discountAmt, sub);

      const totalAfterDiscount = sub - discountAmt;
      // Recalculate GST on discounted amount if needed, or keep original GST
      // For simplicity, keeping original GST calculation
      const finalTotalAmount = totalAfterDiscount + gstAmount;

      setSubtotal(sub);
      setTotalGST(gstAmount);
      setDiscountAmount(discountAmt);
      setGrandTotal(totalAfterDiscount + gstAmount);
      setFinalTotal(finalTotalAmount);
    } else {
      setSubtotal(0);
      setTotalGST(0);
      setDiscountAmount(0);
      setGrandTotal(0);
      setFinalTotal(0);
    }
  }, [products, discount, discountType]);

  // States


// Fetch discount from backend
useEffect(() => {
  const fetchDiscount = async () => {
    try {
      const res = await axios.get(`${baseURL}/api/lead/${id}/discount`);
      if (res.data.success) {
        setDiscount(res.data.Discount || 0);
        setDiscountType(res.data.discountType || "percentage");
      }
    } catch (err) {
      console.error("Error fetching discount:", err);
    }
  };
  fetchDiscount();
}, [id]);

// Handle discount change
const handleDiscountChange = async (e) => {
  let value = parseFloat(e.target.value) || 0;

  if (discountType === "percentage") {
    value = Math.min(value, 100);
  } else {
    value = Math.min(value, subtotal);
  }

  setDiscount(value);

  try {
    const res = await axios.put(`${baseURL}/api/lead/${id}/discount`, {
      discount: value,
      discountType,
    });

    console.log("✅ Discount saved successfully:", res.data);
  } catch (err) {
    console.error("❌ Error saving discount:");
    if (err.response) {
      // Server responded with an error (4xx or 5xx)
      console.error("Status:", err.response.status);
      console.error("Data:", err.response.data);
      console.error("Headers:", err.response.headers);
    } else if (err.request) {
      // No response from server
      console.error("Request made but no response:", err.request);
    } else {
      // Something went wrong in setting up the request
      console.error("Error message:", err.message);
    }
    console.error("Config used:", err.config);

    alert("Failed to update discount in database.");
  }
};

const handleDiscountTypeChange = async (e) => {
  const newType = e.target.value;
  setDiscountType(newType);
  setDiscount(0);

  try {
    await axios.put(`${baseURL}/api/lead/${id}/discount`, {
      discount: 0,
      discountType: newType,
    });
  } catch (err) {
    console.error("Error updating discount type:", err);
  }
};


  // columns for the table
  const columns = [
    {
      key: "product",
      title: "Product",
      render: (row) => (
        <>
          <div><strong>{row.maincategory_name}</strong></div>
          <div className="adminviewproducts-viewlead-text-muted">{row.subcategory_name}</div>
          <div>{row.product_name} - {row.batch}</div>
          <div className="adminviewproducts-viewlead-text-muted">Size: {row.size}</div>
        </>
      )
    },
    {
  key: "product_image",
  title: "Product Image",
  render: (row) => {
    if (!row.product_image) return "-";
    
    const imageUrl = `${baseURL}/Uploads/products/${row.product_image}`;
    
    return (
      <a href={imageUrl} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
        <img 
          src={imageUrl}
          alt={row.product_name || "Product"}
          style={{ 
            width: '50px', 
            height: '50px', 
            objectFit: 'cover',
            borderRadius: '4px',
            cursor: 'pointer',
            border: '1px solid #ddd',
            transition: 'transform 0.2s'
          }}
          onMouseOver={(e) => e.target.style.transform = 'scale(1.1)'}
          onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      </a>
    );
  },
},
    { key: "hsncode", title: "HSN Code", render: (row) => row.hsncode || "N/A" },
    { 
      key: "gstrate", 
      title: "GST (%)", 
      render: (row) => <span className="adminviewproducts-viewlead-badge adminviewproducts-viewlead-bg-light adminviewproducts-viewlead-text-dark">{row.gstrate}%</span>
    },
   { 
  key: "listprice", 
  title: "Price", 
  render: (row, index) => (
    <input
      type="number"
      className="form-control"
      min={0}
      value={row.listprice}
      onChange={(e) => handlePriceChange(index, e.target.value)}
      style={{ width: "100px" }}
    />
  )
},

    {
      key: "quantity",
      title: "Qty",
      render: (row, index) => (
        <input
          type="number"
          className="form-control"
          min={1}
          value={row.quantity}
          onChange={(e) => handleQuantityChange(index, e.target.value)}
          style={{ width: "80px" }}
        />
      )
    },
   {
  key: "total",
  title: "Total",
  render: (row) => `₹${((row.quantity || 0) * (row.listprice || 0)).toFixed(2)}`
},
    {
      key: "actions",
      title: "Actions",
      render: (row) => (
        <button
          className="btn btn-sm btn-danger"
          onClick={() => handleDeleteProduct(row.id)}
        >
          <FiTrash2 />
        </button>
      )
    }
  ];

const handleRegretEmailNavigate = () => {
  navigate(`/s-regret-email/${id}`, { state: { lead: leadInfo, email: leadInfo.email } });
};


  // Check if requote button should be shown
  const showRequoteButton = quotationStatus === "Sent" && leadInfo.opp_status === "Negotiation";

  return (
    <div className="CollapseContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`Collapse ${collapsed ? "collapsed" : ""}`}>
        <div className="adminviewproducts-viewlead-container-fluid adminviewproducts-viewlead-py-2 px-5">
          
          {/* Header Section */}
          <div className="adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center adminviewproducts-viewlead-justify-content-between">
            {/* Left Side: Profile + Name + Email + Phone */}
            <div className="adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center">
              {/* Profile Circle */}
              <div className="adminviewproducts-viewlead-avatar-circle adminviewproducts-viewlead-bg-primary adminviewproducts-viewlead-text-white">
                {leadInfo.lead_name ? leadInfo.lead_name.charAt(0).toUpperCase() : "L"}
              </div>

              {/* Name + Email + Phone beside profile */}
                <div className="adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center" style={{ gap: "20px" }}>
                  {/* Email */}
                  <div className="adminviewproducts-viewlead-lead-detail-item">
                    <FiMail className="adminviewproducts-viewlead-me-2 adminviewproducts-viewlead-text-muted" />
                    <span>{leadInfo.email || "N/A"}</span>
                  </div>

                  {/* Phone */}
                  <div className="adminviewproducts-viewlead-lead-detail-item">
                    <FiPhone className="adminviewproducts-viewlead-me-2 adminviewproducts-viewlead-text-muted" />
                    <span>{leadInfo.contact_number || "N/A"}</span>
                  </div>

                  <button
                    className="adminviewproducts-viewlead-btn adminviewproducts-viewlead-btn-primary adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center"
                    onClick={handleNavigate}
                    disabled={loading}
                  >
                    Raw Email
                  </button>

                  {/* Add Regret Email Button */}
                  <button
                    className="adminviewproducts-viewlead-btn adminviewproducts-viewlead-btn-warning adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center"
                    onClick={handleRegretEmailNavigate}
                    disabled={loading}
                  >
                    Regret Email
                  </button>
                </div>
            </div>

            <div className="flex gap-2">
              {showRequoteButton ? (
                // Show Requote button when conditions are met
                <button
                  className="adminviewproducts-viewlead-btn adminviewproducts-viewlead-btn-info adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center"
                  onClick={() => handleQuoteStatus(id, "Requoted")}
                  disabled={loading}
                >
                  <FiRefreshCw className="adminviewproducts-viewlead-me-1" />
                  {loading ? "Processing..." : "Requote"}
                </button>
              ) : !quotationStatus ? (
                // ✅ Show button only if products exist
                products.length > 0 && (
                  <button
                    className="adminviewproducts-viewlead-btn adminviewproducts-viewlead-btn-success adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center"
                    onClick={() => handleQuoteStatus(id, "Quoted")}
                    disabled={loading}
                  >
                    {loading ? "Updating..." : "Quoted"}
                  </button>
                )
              ) : (
                // ✅ Otherwise show status badge
                <span
  className={`badge d-flex align-items-center px-3 py-2 ${
    quotationStatus === "Approved" || quotationStatus === "Sent"
      ? "bg-success"
      : quotationStatus === "Quoted"
      ? "bg-warning text-dark"
      : quotationStatus === "Requoted"
      ? "bg-info text-dark"
      : "bg-secondary"
  }`}
>
  {quotationStatus}{" "}
  {quotationStatus === "Approved" && "✅"}
  {quotationStatus === "Sent" && "📩"}
  {quotationStatus === "Quoted" && "🟡"}
  {quotationStatus === "Requoted" && "🔄"}
</span>

              )}
            </div>
          </div>

          {/* Products Section - MIDDLE */}
          <div className="adminviewproducts-viewlead-mb-4">
            <div className="adminviewproducts-viewlead-card adminviewproducts-viewlead-shadow-sm adminviewproducts-viewlead-border-0">
              <div className="adminviewproducts-viewlead-card-header adminviewproducts-viewlead-bg-white adminviewproducts-viewlead-py-3">
                <div className="adminviewproducts-viewlead-header-content">
                  <h5 className="adminviewproducts-viewlead-mb-0 adminviewproducts-viewlead-header-title" style={{paddingLeft:"10px"}}>
                    <FiShoppingCart className="adminviewproducts-viewlead-me-2 adminviewproducts-viewlead-text-primary" />
                    Products ({products.length})
                  </h5>
                  <div className="adminviewproducts-viewlead-button-group" style={{paddingRight:"10px"}}>
                    <button
                      className="adminviewproducts-viewlead-btn adminviewproducts-viewlead-btn-primary adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center"
                      onClick={OpenAddModal}
                      disabled={loading}
                    >
                      <FiPlus className="adminviewproducts-viewlead-me-1" /> Add Product
                    </button>
                    <button
                      className="adminviewproducts-viewlead-btn adminviewproducts-viewlead-btn-warning adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center"
                      onClick={() => {
                        const today = new Date();
                        const dateString = today.toISOString().split("T")[0];
                        
                        navigate("/s-view-quotation", {
                          state: {
                            data: {
                              quotationDate: dateString,
                              subtotal,
                              totalGST,
                              grandTotal,
                              discount: discountAmount,
                              discountType,
                              finalTotal,
                            },
                            leadInfo,
                            quotationData: products,
                          },
                        });
                      }}
                      disabled={products.length === 0}
                    >
                      <FiFileText className="adminviewproducts-viewlead-me-1" /> Preview
                    </button>
                    
                    <button
                      className="adminviewproducts-viewlead-btn adminviewproducts-viewlead-btn-outline-primary adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center"
                      onClick={() =>
                        navigate(`/s-view-sent-quotations/${id}`, {
                          state: { leadInfo },
                        })
                      }
                    >
                      <FiEye className="adminviewproducts-viewlead-me-1" /> View Sent
                    </button>
                  </div>
                </div>
              </div>
              <div className="adminviewproducts-viewlead-card-body">
                {loading ? (
                  <div className="adminviewproducts-viewlead-text-center adminviewproducts-viewlead-py-5">
                    <div className="adminviewproducts-viewlead-spinner-border adminviewproducts-viewlead-text-primary" role="status">
                      <span className="adminviewproducts-viewlead-visually-hidden">Loading...</span>
                    </div>
                    <p className="adminviewproducts-viewlead-mt-2 adminviewproducts-viewlead-text-muted">Loading products...</p>
                  </div>
                ) : products.length === 0 ? (
                  <div className="adminviewproducts-viewlead-text-center adminviewproducts-viewlead-py-5">
                    <FiShoppingCart size={48} className="adminviewproducts-viewlead-text-muted adminviewproducts-viewlead-mb-3" />
                    <h5>No products added yet</h5>
                    <p className="adminviewproducts-viewlead-text-muted">Add products to create a quotation</p>
                    <button className="adminviewproducts-viewlead-btn adminviewproducts-viewlead-btn-primary adminviewproducts-viewlead-mt-2" onClick={OpenAddModal}>
                      <FiPlus className="adminviewproducts-viewlead-me-1" /> Add First Product
                    </button>
                  </div>
                ) : (
                  <ReusableTable
                    title=""
                    data={products}
                    columns={columns}
                    initialEntriesPerPage={5}
                    searchPlaceholder="Search products..."
                    striped={true}
                    hover={true}
                  />
                )}
              </div>
            </div>
          </div>

        {/* Quotation Summary Section - BOTTOM */}
<div className="adminviewproducts-viewlead-row">
  {/* Left Side - Terms & Conditions and Quotation Body */}
  <div className="adminviewproducts-viewlead-col-lg-8">
    <QuatationBody 
      leadId={id}
      baseURL={baseURL}
      onUpdateSuccess={(updatedQuotation) => {
        console.log('Quotation body updated:', updatedQuotation);
      }}
    />
     <TermsConditions 
      leadId={id}
      baseURL={baseURL}
      onUpdateSuccess={(updatedTerms) => {
        console.log('Terms updated:', updatedTerms);
      }}
    />
  </div>

  {/* Right Side - Quotation Summary */}
  <div className="adminviewproducts-viewlead-col-lg-4">
    {/* Summary Card */}
    <div className="adminviewproducts-viewlead-card adminviewproducts-viewlead-shadow-sm adminviewproducts-viewlead-border-0 summary-card">
      <div className="adminviewproducts-viewlead-card-header adminviewproducts-viewlead-bg-white adminviewproducts-viewlead-py-3">
        <h5 className="adminviewproducts-viewlead-mb-0" style={{paddingLeft:"10px"}}>
          <FiFileText className="adminviewproducts-viewlead-me-2 adminviewproducts-viewlead-text-success" />
          Quotation Summary
        </h5>
      </div>
      <div className="adminviewproducts-viewlead-card-body">
        <div className="summary-breakdown">
          <div className="summary-row">
            <div className="adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-justify-content-between adminviewproducts-viewlead-mb-2">
              <span className="adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center">
                <FiShoppingCart className="adminviewproducts-viewlead-me-2 adminviewproducts-viewlead-text-muted" />
                Items:
              </span>
              <span className="summary-value">{products.length}</span>
            </div>
          </div>

          <div className="summary-row">
            <div className="adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-justify-content-between adminviewproducts-viewlead-mb-2">
              <span className="adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center">
                <FiDollarSign className="adminviewproducts-viewlead-me-2 adminviewproducts-viewlead-text-muted" />
                Subtotal:
              </span>
              <span className="summary-value">₹{subtotal.toFixed(2)}</span>
            </div>
          </div>

          {/* Discount Input Fields */}
          <div className="summary-row">
            <div className="adminviewproducts-viewlead-mb-3">
              <label className="adminviewproducts-viewlead-form-label adminviewproducts-viewlead-small adminviewproducts-viewlead-text-muted">
                Discount
              </label>

              <div className="input-group input-group-lg">
                {/* Dropdown inside input group as prefix */}
                <select
                  className="form-select"
                  value={discountType}
                  onChange={handleDiscountTypeChange}
                  style={{ maxWidth: '85px' }}
                >
                  <option value="percentage">%</option>
                  <option value="amount">₹</option>
                </select>

                {/* Single input field taking rest of the width */}
                <input
                  type="number"
                  className="form-control"
                  value={discount}
                  onChange={handleDiscountChange}
                  min="0"
                  max={discountType === 'percentage' ? 100 : subtotal}
                  step={discountType === 'percentage' ? 0.1 : 1}
                  placeholder="0"
                />
              </div>
            </div>
          </div>

          {/* Display Discount Amount */}
          {discount > 0 && (
            <div className="summary-row">
              <div className="adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-justify-content-between adminviewproducts-viewlead-mb-2">
                <span className="adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center">
                  <FiPercent className="adminviewproducts-viewlead-me-2 adminviewproducts-viewlead-text-muted" />
                  Discount:
                </span>
                <span className="summary-value adminviewproducts-viewlead-text-danger">-₹{discountAmount.toFixed(2)}</span>
              </div>
            </div>
          )}

          <div className="summary-row">
            <div className="adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-justify-content-between adminviewproducts-viewlead-mb-2">
              <span className="adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center">
                <FiPercent className="adminviewproducts-viewlead-me-2 adminviewproducts-viewlead-text-muted" />
                GST:
              </span>
              <span className="summary-value">₹{totalGST.toFixed(2)}</span>
            </div>
          </div>
          
          <div className="summary-divider"></div>
          
          <div className="summary-total">
            <div className="adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-justify-content-between adminviewproducts-viewlead-fw-bold">
              <span className="adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center total-label">
                <FiDollarSign className="adminviewproducts-viewlead-me-2 adminviewproducts-viewlead-text-success" />
                Grand Total:
              </span>
              <span className="adminviewproducts-viewlead-text-success total-amount">₹{finalTotal.toFixed(2)}</span>
            </div>
          </div>
        </div>

        {products.length === 0 && (
          <div className="adminviewproducts-viewlead-text-center adminviewproducts-viewlead-text-muted adminviewproducts-viewlead-mt-3">
            <small>Add products to see summary</small>
          </div>
        )}
      </div>
    </div>
  </div>
</div>
        </div>

        {/* Add Product Modal */}
        <AddProduct
          show={showModal}
          handleClose={() => setShowModal(false)}
          handleSave={handleSaveProduct}
        />
      </div>
    </div>
  );
};

export default ViewLead;